<div class="icon-bx-wraper style-4 p-2 m-b10 border border-black" style="background: #fcc0c099;">
    <div class="icon-bx">
        <img src="assets/images/info.png" style="width: 40px;" alt="/">
    </div>
    <div class="icon-content">
        <h6 class="dz-title text-black mb-0 fs-5 fw-bolder mb-1">Important
            Notice</h6>
        <p class="mb-0 text-gray fs-6">
            Your order is scheduled to be delivered between 
            <span class="text-red text-bolder">{{ dispatchDateRange }}.</span>
        </p>
    </div>
</div>